import React from 'react'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'
import styled from 'styled-components'
import TitleSection from '../../components/title-section/title-section'
import SectionTC from '../../components/section-tc/section-tc'
import InputTC from '../../components/input-tc/input-tc'
import ButtonTC from '../../components/button-tc/button-tc'
import { device } from '../../config/theme/breakpoints'
import { User } from '@styled-icons/boxicons-regular'
import { CreditCard } from '@styled-icons/feather'
import { Calendar } from '@styled-icons/bootstrap'
import { Check2Square } from '@styled-icons/bootstrap'
import { Location } from '@styled-icons/evil'
import { Telephone } from '@styled-icons/bootstrap'
import { Circle } from '@styled-icons/bootstrap'
import CalendarTC from '../../components/calendar-tc/calendar-tc'
import SelectTC from '../../components/select-tc/select-tc'
import TextareaTC from '../../components/textarea-tc/textarea-tc'
import { RecordCircle } from '@styled-icons/bootstrap'
import { format } from 'date-fns'

const DivCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ContainerForm = styled.div`
    margin: 40px 10px;
    padding: 40px;
    box-shadow: 3px 1px 10px rgb(0,0,0,9%);

    > h4 {
        color: ${p => p.theme.palette.secondary.main}
    }
`
    
const CustomButton = `
    border-radius: 20px 4px 20px 4px;
    margin: inherit;
    margin-top: 40px;
    padding: 8px 15px;

    > div div {
        font-size: 20px;
    }
`
const ContainerTwo = styled(DivCenter)`
    justify-content: space-around;
    flex-wrap: wrap;

    > div {
        width: 100%;

        @media ${device.tablet}{
            width: 50%;
        }
    }
`
const ContainerThree = styled(DivCenter)`
    justify-content: space-around;
    flex-wrap: wrap;

    > div {
        width: 100%;

        @media ${device.tablet}{
            width: 50%;
        }
        
        @media ${device.laptop}{
            width: 33%;
        }
    }
`

const ContainerButton = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`
const ContainerCheckbox = styled.div`
    justify-content: flex-start;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    gap: 15px;
    
    > div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 15px;
        cursor: pointer;
    }

    > div svg {
        width: 20px;
        color: ${p => p.theme.palette.primary.main};
    }
`
const ContainerCheckboxGenero = styled.div`
    justify-content: flex-start;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    gap: 15px;
    
    > div{
      display: flex;
      gap: 10px;
    }

    > div div{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 15px;
        cursor: pointer;
    }

    > div div svg {
        width: 20px;
        color: ${p => p.theme.palette.primary.main};
    }

    @media ${device.tablet}{
      flex-direction: row;
    }
`

const ContainerTitle = styled.div`
  background: ${p => p.theme.palette.primary.main};
  text-transform: uppercase;
  padding: 8px;
  color: white;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 8px;

  h3{
    margin: 0;
  }
`

const ContainerSpecialTitle = styled.div`
  text-align: center;
`
const ContainerTitleExpand = styled.div`
width: 100%;
display: flex;
align-items: center;
justify-content: space-between;
align-content: center;
`
const ContainerCheck = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const ComplaintsBook: React.FunctionComponent = () => {
  // const [statusTerms, setStatusTerms] = React.useState(false)
  const [statusSex, setStatusSex] = React.useState(false)
  const [statusType, setStatusType] = React.useState(false)
  const [statusType2, setStatusType2] = React.useState(false)
  const handleSelectSex = () => setStatusSex(!statusSex)
  const handleSelectType = () => setStatusType(!statusType)
  const handleSelectType2 = () => setStatusType2(!statusType2)

  return (
    <Layout>
        <HeaderOptions />
        <SectionTC>
          <TitleSection title='Reclamaciones' preTitle='Libro de'/>
          <p>Conforme a lo establecido en el Código de Protección y Defensa del Consumidor esta institución cuenta con un Libro de Reclamaciones a tu disposición.</p>
          <ContainerForm>
            <ContainerTitle>
              <h3>Empresa Transportes Chiclayo</h3>
              <h3>S.A.</h3>
              <h3>RUC 20103626448</h3>
            </ContainerTitle>
            <ContainerSpecialTitle>
              <h3>Av. JOSE LEONARDO ORTIZ #010, CHICLAYO - LAMBAYEQUE</h3>
            </ContainerSpecialTitle>
            <ContainerTitle>
              <ContainerTitleExpand>
                <div><h3>Hoja de reclamación</h3></div>
                <div><h3>{format(Date.now(), 'P')}</h3></div>
              </ContainerTitleExpand>
            </ContainerTitle>
            <ContainerTitle><h3>Identificación del consumidor reclamante</h3></ContainerTitle>
            <ContainerTwo>
                <div>
                  <SelectTC
                    textHolder='Seleccione tipo de documento'
                    icon={<CreditCard />}
                    listOptions={['DNI','Pasaporte']}
                  />
                </div>
                <div><InputTC type='text' textHolder='Nro de documento' icon={<Check2Square />}/></div>
            </ContainerTwo>
            <ContainerTwo>
                <div><InputTC type='text' textHolder='Nombres completos' icon={<User />}/></div>
                <div><InputTC type='text' textHolder='Apellido Paterno' icon={<User />}/></div>
            </ContainerTwo>
            <ContainerTwo>
                <div><InputTC type='text' textHolder='Apellido Materno' icon={<User />}/></div>
                <div><InputTC type='text' textHolder='Dirección' icon={<Location />}/></div>
            </ContainerTwo>
            <ContainerTwo>
                <div><InputTC type='text' textHolder='Telefono' icon={<Telephone />}/></div>
                <div><InputTC type='text' textHolder='E-mail' icon={<CreditCard />}/></div>
            </ContainerTwo>
            <ContainerTwo>
                <div>
                    <CalendarTC
                        icon={<Calendar />}
                        textHolder='Seleccione fecha de nacimiento'
                        className={`width: 98%;`}
                    />
                </div>
                <ContainerCheckboxGenero>
                    <p>Seleccione su género</p>
                    <div>
                      <div onClick={handleSelectSex}>
                          {statusSex ? <RecordCircle /> : <Circle />}
                          <p>Masculino</p>
                      </div>
                      <div onClick={handleSelectSex}>
                          {!statusSex ? <RecordCircle /> : <Circle />}
                          <p>Femenino</p>
                      </div>
                    </div>
                </ContainerCheckboxGenero>
            </ContainerTwo>
            <ContainerTwo>
                <div>
                  <SelectTC
                    textHolder='Seleccione tipo de documento'
                    icon={<CreditCard />}
                    listOptions={['DNI','Pasaporte']}
                  />
                </div>
                <div><InputTC type='text' textHolder='Nro de documento del apoderado' icon={<Check2Square />}/></div>
            </ContainerTwo>
            <ContainerTwo>
                <div><InputTC type='text' textHolder='Nombres completos del apoderado' icon={<User />}/></div>
                <div><InputTC type='text' textHolder='Apellido del apoderado' icon={<User />}/></div>
            </ContainerTwo>
            <ContainerTitle><h3>Identificación del servicio contratado</h3></ContainerTitle>
            <ContainerCheck>
              <ContainerCheckbox>
                <div onClick={handleSelectType2}>
                    {statusType2 ? <RecordCircle /> : <Circle />}
                    <p>*Producto</p>
                </div>
                <div onClick={handleSelectType2}>
                    {!statusType2 ? <RecordCircle /> : <Circle />}
                    <p>*Servicio</p>
                </div>
              </ContainerCheckbox>
            </ContainerCheck>
            <ContainerTwo>
                <div><InputTC type='text' textHolder='Monto reclamado' icon={<User />}/></div>
                <div><InputTC type='text' textHolder='Descripción' icon={<User />}/></div>
            </ContainerTwo>
            <ContainerTitle><h3>Detalle de la reclamacióny pedido del consumidor</h3></ContainerTitle>
            <ContainerCheck>
              <ContainerCheckbox>
                <div onClick={handleSelectType}>
                    {statusType ? <RecordCircle /> : <Circle />}
                    <p>*Reclamo</p>
                </div>
                <div onClick={handleSelectType}>
                    {!statusType ? <RecordCircle /> : <Circle />}
                    <p>*Queja</p>
                </div>
              </ContainerCheckbox>
            </ContainerCheck>
            {statusType && (
              <div>
                <ContainerThree>
                <div><SelectTC textHolder='Seleccione el Voucher' icon={<Location />}/></div>
                <div><InputTC type='text' textHolder='B001'/></div>
                <div><InputTC type='text' textHolder='1256'/></div>
                </ContainerThree>
                <ContainerThree>
                    <div><SelectTC textHolder='Seleccione el motivo' icon={<Location />}/></div>
                    <div><SelectTC textHolder='Provincia' icon={<Location />}/></div>
                    <div><SelectTC textHolder='Seleccione el terminal' icon={<Location />}/></div>
                </ContainerThree>
              </div>
            )}
            
            {!statusType && (
              <div>
                <ContainerThree>
                  <div><SelectTC textHolder='Seleccione el motivo' icon={<Location />}/></div>
                  <div>
                    <CalendarTC
                        icon={<Calendar />}
                        textHolder='Seleccione fecha de nacimiento'
                        className={`width: 98%;`}
                    />
                  </div>
                  <div><SelectTC textHolder='Seleccione el terminal' icon={<Location />}/></div>
                </ContainerThree>
              </div>
            )}
            <div>
              <TextareaTC textHolder='Ingrese el detalle de su reclamo'/>
            </div>
            <div>
              <TextareaTC textHolder='Ingrese el pedido de su reclamo'/>
            </div>
            <ContainerTwo>
                <div>
                  <h4>Reclamo:</h4>
                  <p>Disconformidad relacionada a los productos o servicios.</p>
                </div>
                <div>
                  <h4>Queja:</h4>
                  <p>Disconformidad no relacionada a los productos o servicios; o malestar o descontento respecto a la atención al público.</p>
                </div>
            </ContainerTwo>
            <ContainerTitle><h3>Observaciones y acciones adoptadas por el proveedor</h3></ContainerTitle>
            <div>
              <h4>Ley Nº 29571, Artículo 24.- Servicio de atención de reclamos:</h4>
              <p>24.1 Sin perjuicio del derecho de los consumidores de iniciar las acciones correspondientes ante las autoridades competentes, los proveedores están obligados a atender los reclamos presentados por sus consumidores y dar respuesta a los mismos en un plazo no mayor a treinta (30) días calendario. Dicho plazo puede ser extendido por otro igual cuando la naturaleza del reclamo los justifique, situación que es puesta en conocimiento del consumidor antes de la culminación del plazo inicial.</p>
            </div>
            {/* <ContainerTerms onClick={handleStatusTerms}>
                {statusTerms ? <CheckCircle /> : <Circle />}
                <p>Debes aceptar nuestros términos y condiciones</p>
            </ContainerTerms> */}
            <ContainerButton>
                <ButtonTC text='Enviar' className={CustomButton}/>
            </ContainerButton>
          </ContainerForm>
        </SectionTC>
    </Layout>
  )
}

export default ComplaintsBook